import { z } from 'zod';
export const NotificationKindSchema = z.enum([
    'NOTICE',
    'UPDATE',
    'EVENT',
    'REWARD',
    'REFUND',
    'PURCHASE',
]);
export const NotificationLinkSchema = z
    .string()
    .max(500)
    .refine((value) => /^\/(?![\/\\])/.test(value) &&
    !/[\\\u0000-\u0020\u007f]/.test(value) &&
    !/^\/(?:auth(?:[\/?#-]|$)|logout(?:[\/?#]|$))/.test(value), '이동 경로는 사이트 내부 경로로 입력해 주세요');
export const NotificationItemSchema = z.object({
    id: z.string(),
    kind: NotificationKindSchema,
    title: z.string(),
    body: z.string().optional(),
    linkUrl: NotificationLinkSchema.optional(),
    createdAt: z.string().datetime(),
    readAt: z.string().datetime().nullable(),
});
export const NotificationsResponseSchema = z.object({
    items: z.array(NotificationItemSchema),
    unreadCount: z.number().int().nonnegative(),
    nextCursor: z.string().nullable(),
    asOf: z.string().datetime(),
    hasRead: z.boolean(),
    hasHistory: z.boolean(),
});
export const NotificationUnreadCountSchema = z.object({
    unreadCount: z.number().int().nonnegative(),
});
export const NotificationRangeSchema = z.enum(['all', 'recent', 'history']);
export const NotificationClearReadResponseSchema = NotificationUnreadCountSchema.extend({
    hiddenCount: z.number().int().nonnegative(),
});
export const NotificationReadSchema = z.union([
    z.object({ all: z.literal(true) }).strict(),
    z
        .object({
        ids: z
            .array(z.string().regex(/^(announcement|notification):[a-z0-9]+$/))
            .min(1)
            .max(100),
    })
        .strict(),
]);
export const UpdateKindSchema = z.enum(['NEW', 'IMPROVED', 'FIXED']);
export const UpdateChangesSchema = z
    .object({
    NEW: z
        .array(z
        .string()
        .trim()
        .min(1, '변경 내용을 입력해 주세요')
        .max(2000, '변경 내용은 2,000자 이하로 입력해 주세요'))
        .max(100, '분류별 변경 항목은 100개 이하로 입력해 주세요')
        .optional(),
    IMPROVED: z
        .array(z
        .string()
        .trim()
        .min(1, '변경 내용을 입력해 주세요')
        .max(2000, '변경 내용은 2,000자 이하로 입력해 주세요'))
        .max(100, '분류별 변경 항목은 100개 이하로 입력해 주세요')
        .optional(),
    FIXED: z
        .array(z
        .string()
        .trim()
        .min(1, '변경 내용을 입력해 주세요')
        .max(2000, '변경 내용은 2,000자 이하로 입력해 주세요'))
        .max(100, '분류별 변경 항목은 100개 이하로 입력해 주세요')
        .optional(),
})
    .refine((changes) => Object.values(changes).some((items) => (items?.length ?? 0) > 0), '변경 내용을 하나 이상 입력해 주세요');
export const UpdateContentSchema = z.object({
    slug: z
        .string()
        .min(1, '상세 주소를 입력해 주세요')
        .max(120, '상세 주소는 120자 이하로 입력해 주세요')
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, '주소는 영문 소문자·숫자·하이픈으로 입력해 주세요'),
    version: z
        .string()
        .trim()
        .min(1, '버전을 입력해 주세요')
        .max(30, '버전은 30자 이하로 입력해 주세요'),
    date: z.iso.date({ error: '올바른 업데이트 날짜를 입력해 주세요' }),
    changes: UpdateChangesSchema,
});
export const UpdateEntrySchema = UpdateContentSchema.extend({
    title: z.string(),
    summary: z.string(),
});
export const UpdatesResponseSchema = z.object({
    items: z.array(UpdateEntrySchema),
    nextCursor: z.string().nullable(),
});
export const UpdateDetailResponseSchema = z.object({
    entry: UpdateEntrySchema,
    newer: UpdateEntrySchema.nullable(),
    older: UpdateEntrySchema.nullable(),
});
export const AnnouncementInputSchema = z.object({
    title: z.string().trim().min(1).max(150),
    summary: z.string().trim().max(500).default(''),
    body: z.string().trim().min(1).max(20000),
    category: z.enum(['NOTICE', 'UPDATE', 'EVENT']),
    linkUrl: NotificationLinkSchema.nullable().default(null),
    isActive: z.boolean().default(false),
    update: UpdateContentSchema.nullable().default(null),
});
export const AnnouncementSchema = AnnouncementInputSchema.extend({
    id: z.string(),
    publishedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const AdminAnnouncementsResponseSchema = z.object({
    items: z.array(AnnouncementSchema),
    total: z.number().int().nonnegative(),
    pageSize: z.number().int().positive(),
});
//# sourceMappingURL=notification.js.map